import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
 import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../Service/authConfig';
import toast from "react-hot-toast";
function LoginPage() {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();
 
  const isIosSafari = () => {
  const ua = navigator.userAgent;
  
  return (
    /iP(ad|hone|od)/.test(ua) &&
    /WebKit/.test(ua) &&
    !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua)
  );
};

    const handleLogin = () => {
    if (inProgress !== InteractionStatus.None) {
      toast("Login is already in progress. Please wait.", { icon: "⏳" });
      return;
    }

    if (isIosSafari()) {
      instance.loginRedirect(loginRequest);
        navigate("/home");
    } else {
      instance.loginPopup(loginRequest)
        .then(response => {
          instance.setActiveAccount(response.account);
           navigate("/home");
          toast.success("Login successful!");
        })
        .catch(err => {
          console.error("Login failed", err);
          toast.error("Login failed. Please try again.");
        });
    }
  };
// useEffect(() => {
//   const checkSession = async () => {
//     try {
//       const response = await instance.ssoSilent(loginRequest);
//       instance.setActiveAccount(response.account);
//       navigate("/home");
//     } catch (e) {
//       if (e instanceof InteractionRequiredAuthError) {
//         // fallback to redirect login if silent fails
// //await instance.loginRedirect(loginRequest);
//       } else {
//         console.error(e);
//       }
//     }
//   };
//   checkSession();
// }, []);


  return (

   <div className="bg-loginbg bg-cover bg-center bg-no-repeat min-h-screen w-full">

  <div className="flex flex-col md:flex-row min-h-screen">

    {/* Left side - intro section */}
    <div className="md:w-7/10 w-full flex items-center justify-center px-8 md:px-20 py-12 md:py-0">
      <div>
        <h1 className="text-primary-500 font-bold text-4xl sm:text-5xl md:text-6xl leading-tight">
          AHC SHAML Platform
        </h1>
        <h3 className="text-primary-500 text-xl sm:text-2xl md:text-3xl mt-3 max-w-lg">
          Empowering Your Workforce, Enhancing Your Future
        </h3>
      </div>
    </div>

    {/* Right side - login section */}
    <div className="md:w-3/10 w-full bg-white/50 flex flex-col justify-center items-center py-12 px-8">
      <img src="images/logo.svg" alt="Logo"   className=" mb-10 h-8 sm:h-10 lg:h-12 w-auto"/>
      <h3 className="text-primary-500 font-bold text-2xl sm:text-3xl mb-2">Login</h3>
      <h4 className="text-gray-500 text-sm sm:text-base font-semibold mb-6 text-center max-w-xs">
        Please click 'Windows Authentication' to access the portal.
      </h4>
      <button onClick={handleLogin} aria-label="Windows Authentication Login">
        <img src="images/login.svg" alt="Login" className="pt-3" />
      </button>
    </div>

  </div>

</div>

    // <div style={{ padding: 40 }}>
    //   <h2>Login with Microsoft</h2>
    //   <button onClick={handleLogin}>Login</button>
    // </div>
  );
}

export default LoginPage;
